// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s-Ti","type":"styles_type__3CCM5","choices":"styles_choices__36_YL"};